import { Component, OnInit, Input } from "@angular/core";
// import { Comment } from 'src/app/models/comment';
import { AssetComments } from "src/app/models/assetComments";
import { AngularWaitBarrier } from "blocking-proxy/built/lib/angular_wait_barrier";
import { HttpService } from "../../shared/services/http.service";
import { UserService } from "src/app/modules/userModule/shared/user.service";
import { Asset } from "src/app/models/asset";
import { User } from "src/app/models/user";

@Component({
  selector: "app-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.css"]
})
export class CommentsComponent implements OnInit {
  @Input() asset: Asset;
  @Input() selectedVersion: string;

  commentSubjectError = false;
  commentDescriptionError = false;
  oldComment: AssetComments = new AssetComments();
  showAddCommentDiv = false;
  newComment: AssetComments;
  commentedUserProfileImageURL: string = 'assets/img/userDefault.png';

  constructor(private httpService: HttpService, public userService: UserService) { }

  ngOnInit() {
    this.asset.comments = this.asset.comments ? this.commentReverse(this.asset.comments) : new Array<AssetComments>();
    this.mapProfileImages();
  }

  mapProfileImages(){
    this.asset.comments.forEach(comm=>{
      this.userService.fetchUserProfileImage(comm.createdByUser).subscribe((userImage) => {
        if(userImage != null){
          comm.commenterProfile = 'data:image/png;base64,' + userImage;
        }
        else{
          comm.commenterProfile = 'assets/img/userDefault.png';
        }
      });
    });
  }

  commentReverse(comment) {
    return comment.reverse()
  }

  commentDateDiff(date): string {
    let commentDate = new Date(date);
    let dateDiff = Math.abs(new Date(commentDate).getTime() - new Date().getTime());
    let diffinDays = Math.floor(dateDiff / (1000 * 3600 * 24));
    let commentDateDiff = "";
    if (diffinDays === 0) {
      commentDateDiff = "Today";
    } else {
      if (diffinDays < 30) {
        commentDateDiff = diffinDays + " day(s) ago";
      } else {
        if (diffinDays >= 30 && diffinDays < 365) {
          commentDateDiff = Math.floor(diffinDays / 30) + " month(s) ago";
        } else {
          commentDateDiff = Math.floor(diffinDays / 365) + " year(s) ago";
        }
      }
    }
    return commentDateDiff;
  }

  deleteComment(comment: AssetComments) {
    // delete comment with id from the asset
    // if (confirm(`The comment will be deleted`)) {
      this.httpService.deleteComment(this.asset._id, this.asset.name, comment._id, this.userService.loggendInUser.userEmailId).subscribe(
        () => {
          this.asset.comments.splice(this.asset.comments.indexOf(comment), 1);
        }, err => {
          console.error(err);
        }, () => {
          console.log('deleted')
        }
      );
    // }
  }

  toggledEdit(comment: AssetComments) {
    // edit comment with id from the asset
    if (!comment.displayEdit) {
      this.oldComment = JSON.parse(JSON.stringify(comment));
      comment.displayEdit = !comment.displayEdit;
    } else {
      comment.description = this.oldComment.description;
      comment.subject = this.oldComment.subject;
      comment.displayEdit = false;
    }

  }

  submitEditComment(comment: AssetComments) {
    this.httpService.updateComment(comment, this.asset._id, this.asset.name).subscribe(
      (data) => {
        console.log(data, "updated")
        comment.displayEdit = !comment.displayEdit;
      }, err => {
        console.error(err);
      }, () => {
        console.log('updated')
      }
    )
  }

  showAddComment() {
    this.newComment = new AssetComments();
    this.newComment.subject = "";
    this.newComment.description = "";
    this.showAddCommentDiv = true;
    this.commentSubjectError = false;
    this.commentDescriptionError = false;
  }

  validateComment(): boolean {
    let isValid = true;
    if (!this.newComment.subject || "" === this.newComment.subject.trim()) {
      isValid = false;
      this.commentSubjectError = true;
    } else {
      this.commentSubjectError = false;
    }
    if (!this.newComment.description || "" === this.newComment.description.trim()) {
      isValid = false;
      this.commentDescriptionError = true;
    } else {
      this.commentDescriptionError = false;
    }
    return isValid;
  }

  addComment() {
    if (this.validateComment()) {
      let loggedInUser = JSON.parse(sessionStorage.getItem("userinfo")) as User;
      this.newComment.createdByUser = loggedInUser.userEmailId;
      this.newComment.userName = loggedInUser.name;
      this.newComment.createdOn = new Date();
      this.newComment.forAssetVersion = Number(this.selectedVersion);

      this.httpService.addComment(this.asset._id, this.asset.name, this.newComment).subscribe(
        (data: Array<AssetComments>) => {
          if (null !== data) {
            this.asset.comments = data.reverse();
          }
          this.showAddCommentDiv = false;
        },
        error => { },
        ()=>{
          this.mapProfileImages();
        }
      );
    }
  }

  fetchUserProfileImage(userEmailId: string) {
    let subscription = this.userService.fetchUserProfileImage(userEmailId).subscribe((userImage) => {
      if(userImage != null){
        this.commentedUserProfileImageURL = 'data:image/png;base64,' + userImage;
        subscription.unsubscribe();
      }
    });
  }
}
